const galleryConfigs = {
    galleryConfig2022: {
        eventName: "SEMARANG-10K-2022",
        photographers: [],
        locations: [
            "RPC",
            "Start",
            "RRI Ahmad Yani",
            "BCA Pemuda",
            "Hotel Getz",
            "IBC Blenduk",
            "Marabunta",
            "Gereja Gedangan",
            "Queen City Pemuda",
            "Hotel Amaris",
            "Sendawa",
            "Lawang Sewu",
            "Jembatan Mberok",
            "Paragon",
            "Start/Finish",
            "Kid Dash",
        ],
    },
    galleryConfig2023: {
        eventName: "SEMARANG 10K 2023",
        photographers: [],
        locations: [
            "Start",
            "Lawang Sewu",
            "RRI Ahmad Yani",
            "Gets Hotel",
            "IBC Blenduk",
            "Marabunta",
            "Jembatan Mberok",
            "Amaris Hotel",
            "Finish",
            "Venue",
        ],
    },
    galleryConfig2024: {
        eventName: "SEMARANG 10K 2024",
        photographers: [],
        locations: [
            "Start",
            "Finish",
            "Lawang Sewu",
            "Ahmad Yani",
            "Museum Kota Lama",
            "Kepodang",
            "Jembatan Mberok",
            "JPO Pemuda",
            "Before Finish",
        ],
    },
    galleryConfig2025: {
        eventName: "Semarang 10k 2025",
        photographers: [],
        locations: [
            "Start",
            "Finish",
            "Lawang Sewu",
            "Ahmad Yani",
            "Museum Kota Lama",
            "Kepodang",
            "Jembatan Mberok",
            "Before Finish",
            "Venue",
            "Kids Dash"
        ],
    },
};

export default galleryConfigs;
